import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { pipe, Record } from '@blade/std-lib'
import { CheckMarkIcon, useHapticFeedback } from '@blade/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

export type AcknowledgmentValue = {
  first: boolean
  second: boolean
  third: boolean
}
type Props = {
  value: AcknowledgmentValue
  onChange: (value: AcknowledgmentValue) => void
} & ClassNameProps

export const WalletAcknowledgments: React.FC<Props> = ({
  onChange,
  value,
  className,
}) => {
  const { t } = useTranslation()
  const haptics = useHapticFeedback()
  const iconSize = 18

  const createToggle = (item: keyof AcknowledgmentValue) => () => {
    haptics.impactOccurred('light')
    onChange(pipe(value, Record.set(item, !value[item])))
  }

  return (
    <Root className={className}>
      <Item onClick={createToggle('first')}>
        <Icon $checked={value.first} size={iconSize} />
        <ItemText>{t('wallet.export_wallet.storing_warning')}</ItemText>
      </Item>
      <Item onClick={createToggle('second')}>
        <Icon $checked={value.second} size={iconSize} />
        <ItemText>
          {t('wallet.export_wallet.do_not_share_recovery_phrase')}
        </ItemText>
      </Item>
      <Item onClick={createToggle('third')}>
        <Icon $checked={value.third} size={iconSize} />
        <ItemText>{t('wallet.export_wallet.recovery_phrase_warning')}</ItemText>
      </Item>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 8px;
  margin-block: 24px;
`

const Item = styled.div`
  background: var(--backgroundA-2);

  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 8px;
  padding-inline: 10px 16px;
  padding-block: 6px 8px;
  align-items: center;

  cursor: pointer;
  border-radius: 8px;

  transition: all 0.15s linear;

  &:hover {
    background: var(--backgroundA-3);
  }
`

const ItemText = styled.div`
  color: var(--text-10);

  font-size: 11px;
  font-weight: 400;
  line-height: 15px;
`

const Icon = styled(CheckMarkIcon)<{ $checked: boolean }>`
  color: ${({ $checked }) =>
    $checked ? 'var(--success-9)' : 'var(--textA-3)'};

  transition: all 0.1s linear;
`
